import { type PartnerEvent } from '@/api/routes/partners/partners.events.api';
import Chip from '@/components/Chip';
import {
  PARTNER_EVENT_STATUS_CHIP,
  getPartnerEventDisplayStatus,
  partnerEventStatusLabel,
} from '@/domain/events/utils';

interface Props {
  event: Pick<PartnerEvent, 'reviewStatus' | 'canceledAt'>;
}

/** Status chip shared by the list and the detail (P08, P10–P13). */
const EventStatusChip = ({ event }: Props) => {
  const status = getPartnerEventDisplayStatus(event);
  return (
    <Chip
      size="xsmall"
      label={partnerEventStatusLabel[status]}
      {...PARTNER_EVENT_STATUS_CHIP[status]}
    />
  );
};

export default EventStatusChip;
